import { createTheme, ThemeProvider } from '@mui/material';
import { blue } from '@mui/material/colors';

import ReactDOM from "react-dom/client";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Home from './screens/home';
import Login from './screens/login';
import CssBaseline from '@mui/material/CssBaseline';
import ProtectedPage from './components/protected-page';

import { Provider } from 'react-redux'
import { store } from './redux/store'
import { SnackbarProvider } from 'notistack';
import Cantiere from './screens/cantiere';
import Marcature from './screens/marcature';
import Operatore from './screens/operatore';

import "./index.css"; 

const theme = createTheme({
  palette: {
    mode:'dark',
    background: {
      default: "#222222"
    },
    text: {
      primary: "#ffffff"
    },
    primary: {
      main: '#f39200'
    },
    secondary: {
      main: blue[500]
    },
  }
});
 
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <SnackbarProvider maxSnack={3}>
      <Provider store={store}>
        <BrowserRouter basename="/incarico/appello">
          <Routes>
            <Route path="/" element={<ProtectedPage><Home /></ProtectedPage>} />
            <Route path="/cantiere/:id" element={<ProtectedPage><Cantiere /></ProtectedPage>} />
            <Route path="/marcature/" element={<ProtectedPage><Marcature /></ProtectedPage>} />
            <Route path="/operatore/:id" element={<ProtectedPage><Operatore /></ProtectedPage>} />
            <Route path="login" element={<Login />}/>
          </Routes>
        </BrowserRouter>
      </Provider>
    </SnackbarProvider>
  </ThemeProvider>

);
